import { ErrorHandler } from '@angular/core';
import { logger } from './logger';

export class LoggerErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    logger.captureException(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/logger-error-handler.ts